"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _SZWBUSP4cjs = require('../__chunks/SZWBUSP4.cjs');


var _ZMH55N2Icjs = require('../__chunks/ZMH55N2I.cjs');
require('../__chunks/OTCKJ4OK.cjs');
require('../__chunks/6P52IAFY.cjs');
require('../__chunks/PFM4PJSG.cjs');
require('../__chunks/SARAALGA.cjs');
require('../__chunks/MWXEIKZX.cjs');
require('../__chunks/T3QB4FR3.cjs');


var _FH6HQ5JNcjs = require('../__chunks/FH6HQ5JN.cjs');




var _PTOCUU2Dcjs = require('../__chunks/PTOCUU2D.cjs');


var _3BSDKDKDcjs = require('../__chunks/3BSDKDKD.cjs');
require('../__chunks/XMDZRF6Y.cjs');

// src/tooltip/tooltip-anchor.tsx




var _misc = require('@ariakit/core/utils/misc');
var _store = require('@ariakit/core/utils/store');
var _react = require('react');
var TagName = "div";
var globalStore = _store.createStore.call(void 0, {
  activeStore: null
});
function createRemoveStoreCallback(store) {
  return () => {
    const { activeStore } = globalStore.getState();
    if (activeStore !== store) return;
    globalStore.setState("activeStore", null);
  };
}
var useTooltipAnchor = _PTOCUU2Dcjs.createHook.call(void 0, 
  function useTooltipAnchor2({ store, showOnHover = true, ...props }) {
    const context = _SZWBUSP4cjs.useTooltipProviderContext.call(void 0, );
    store = store || context;
    _misc.invariant.call(void 0, 
      store,
      process.env.NODE_ENV !== "production" && "TooltipAnchor must receive a `store` prop or be wrapped in a TooltipProvider component."
    );
    const canShowOnHoverRef = _react.useRef.call(void 0, false);
    _react.useEffect.call(void 0, () => {
      return _store.sync.call(void 0, store, ["mounted"], (state) => {
        if (state.mounted) return;
        canShowOnHoverRef.current = false;
      });
    }, [store]);
    _react.useEffect.call(void 0, () => {
      if (!store) return;
      return _misc.chain.call(void 0, 
        // Immediately remove the current store from the global store when
        // the component unmounts. This is useful, for example, to avoid
        // showing tooltips immediately on serial tests.
        createRemoveStoreCallback(store),
        _store.sync.call(void 0, store, ["mounted", "skipTimeout"], (state) => {
          if (!store) return;
          if (state.mounted) {
            const { activeStore } = globalStore.getState();
            if (activeStore !== store) {
              activeStore == null ? void 0 : activeStore.hide();
            }
            return globalStore.setState("activeStore", store);
          }
          const id = setTimeout(
            createRemoveStoreCallback(store),
            state.skipTimeout
          );
          return () => clearTimeout(id);
        })
      );
    }, [store]);
    const onMouseEnterProp = props.onMouseEnter;
    const onMouseEnter = _3BSDKDKDcjs.useEvent.call(void 0, (event) => {
      onMouseEnterProp == null ? void 0 : onMouseEnterProp(event);
      canShowOnHoverRef.current = true;
    });
    const onFocusVisibleProp = props.onFocusVisible;
    const onFocusVisible = _3BSDKDKDcjs.useEvent.call(void 0, (event) => {
      onFocusVisibleProp == null ? void 0 : onFocusVisibleProp(event);
      if (event.defaultPrevented) return;
      store == null ? void 0 : store.setAnchorElement(event.currentTarget);
      store == null ? void 0 : store.show();
    });
    const onBlurProp = props.onBlur;
    const onBlur = _3BSDKDKDcjs.useEvent.call(void 0, (event) => {
      onBlurProp == null ? void 0 : onBlurProp(event);
      if (event.defaultPrevented) return;
      const { activeStore } = globalStore.getState();
      canShowOnHoverRef.current = false;
      if (activeStore === store) {
        globalStore.setState("activeStore", null);
      }
    });
    const type = _FH6HQ5JNcjs.useStoreState.call(void 0, store, "type");
    const contentId = _FH6HQ5JNcjs.useStoreState.call(void 0, store, (state) => {
      var _a;
      return (_a = state.contentElement) == null ? void 0 : _a.id;
    });
    props = {
      "aria-labelledby": type === "label" && props["aria-label"] == null ? contentId : void 0,
      ...props,
      onMouseEnter,
      onFocusVisible,
      onBlur
    };
    props = _ZMH55N2Icjs.useHovercardAnchor.call(void 0, {
      store,
      showOnHover(event) {
        if (!canShowOnHoverRef.current) return false;
        if (_misc.isFalsyBooleanCallback.call(void 0, showOnHover, event)) return false;
        const { activeStore } = globalStore.getState();
        if (!activeStore) return true;
        store == null ? void 0 : store.show();
        return false;
      },
      ...props
    });
    return props;
  }
);
var TooltipAnchor = _PTOCUU2Dcjs.forwardRef.call(void 0, function TooltipAnchor2(props) {
  const htmlProps = useTooltipAnchor(props);
  return _PTOCUU2Dcjs.createElement.call(void 0, TagName, htmlProps);
});



exports.TooltipAnchor = TooltipAnchor; exports.useTooltipAnchor = useTooltipAnchor;
